import { GetterTree } from 'vuex';

import { State } from './state';

export type Getters = {
  getGrids(state: State): any;
  gridByKey(state: State): (gridName: string) => any;
};

export const getters: GetterTree<State, any> & Getters = {
  getGrids: (state) => state.grids,
  gridByKey: (state) => (gridName: string) => state.grids?.[gridName]
};
